import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import classes from "./index.module.scss";

export default function CircularIndeterminate() {
  return (
    <div className={classes.container}>
      <CircularProgress />
    </div>
  );
}
